import React from 'react'

import { ConfirmationDialog, DialogContent } from '@front/squirtle'
import ActiveJobs from './activeJobs'

const Component = ({ handleSubmit }) =>
  <ConfirmationDialog
    name={'show_active_jobs'}
    onConfirm={handleSubmit}
  >
    <DialogContent>
      <ActiveJobs />
    </DialogContent>
  </ConfirmationDialog>


export default Component
